// @ts-nocheck
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#wi-predictive-searchid');
    this.input.addEventListener('input', () => this.onChange());
    this.reset();
    this.openAndCloseSearchPop();
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&section_id=wi-predictive-search&resources[fields]=title,product_type,variants.sku,tag,vendor`)
      .then(response => {
        if (!response.ok) { this.close(); throw new Error(response.status); }
        return response.text();
      })
      .then(text => {
        const currentTerm = this.input.value.trim();
        if (!currentTerm || currentTerm !== searchTerm) { this.close(); return; }

        const doc = new DOMParser().parseFromString(text, 'text/html');

        // Products grid
        const products = doc.querySelector('.WI_ps_products');
        const viewAll  = doc.querySelector('.WI_ps_view_all');
        const queries  = doc.querySelector('.WI_ps_queries ul');

        const proEl  = this.querySelector('.WI_search_results_pro');
        const btnEl  = this.querySelector('.WI_search_results_btn');
        const label  = this.querySelector('.WI_search_products_label');

        if (products) {
          // Render products as a UL for the grid
          proEl.innerHTML = `<ul class="WI_productResult_proUl">${
            Array.from(products.querySelectorAll('.WI_ps_product_card'))
              .map(card => `<li>${card.outerHTML}</li>`)
              .join('')
          }</ul>`;
          if (label) label.style.display = 'block';
        } else {
          const noRes = doc.querySelector('.WI_ps_no_results');
          proEl.innerHTML = noRes ? noRes.outerHTML : '';
          if (label) label.style.display = 'none';
        }

        btnEl.innerHTML = viewAll ? viewAll.innerHTML : '';

        // Suggestions from query results
        const suggDesktop = this.querySelector('.WI_search_in_con_sugg_resultText');
        const suggMobile  = this.querySelector('.WI_search_results_sugg_resultText');

        if (queries && queries.querySelectorAll('li').length > 0) {
          const ul = `<ul>${queries.innerHTML}</ul>`;
          if (suggDesktop) { suggDesktop.innerHTML = ul; suggDesktop.style.display = 'flex'; setTimeout(() => { suggDesktop.style.opacity = '1'; }, 10); }
          if (suggMobile)  { suggMobile.innerHTML  = ul; suggMobile.style.display  = 'block'; setTimeout(() => { suggMobile.style.opacity  = '1'; }, 10); }
          this._hideSugg();
        } else {
          if (suggDesktop) { suggDesktop.style.opacity = '0'; suggDesktop.style.display = 'none'; }
          if (suggMobile)  { suggMobile.style.opacity  = '0'; suggMobile.style.display  = 'none'; }
          this._showSugg();
        }

        this.querySelector('.WI_search_reset').style.opacity = '1';
        document.dispatchEvent(new CustomEvent('imgLoad', { bubbles: true }));
        this._initCarousel();
      })
      .catch(error => { this.close(); throw error; });
  }

  _hideSugg() {
    const t = this.querySelector('.WI_search_in_con_sugg_text');
    const m = this.querySelector('.WI_search_results_sugg_text');
    if (t) { t.style.opacity = '0'; setTimeout(() => t.style.display = 'none', 110); }
    if (m) { m.style.opacity = '0'; setTimeout(() => m.style.display = 'none', 110); }
  }

  _showSugg() {
    const t = this.querySelector('.WI_search_in_con_sugg_text');
    const m = this.querySelector('.WI_search_results_sugg_text');
    if (t) { t.style.display = 'flex'; setTimeout(() => t.style.opacity = '1', 10); }
    if (m) { m.style.display = 'flex'; setTimeout(() => m.style.opacity = '1', 10); }
  }

  reset() {
    this.querySelector('.WI_search_reset')?.addEventListener('click', () => {
      this.input.value = '';
      this.onChange();
      this.input.focus();
    });
  }

  close() {
    const proEl = this.querySelector('.WI_search_results_pro');
    const btnEl = this.querySelector('.WI_search_results_btn');
    const label = this.querySelector('.WI_search_products_label');
    if (proEl) proEl.innerHTML = '';
    if (btnEl) btnEl.innerHTML = '';
    if (label) label.style.display = 'none';
    const prevBtn = this.querySelector('.WI_search_carousel_prev');
    const nextBtn = this.querySelector('.WI_search_carousel_next');
    if (prevBtn) prevBtn.setAttribute('disabled', '');
    if (nextBtn) nextBtn.setAttribute('disabled', '');
    this.querySelector('.WI_search_reset').style.opacity = '0';
    this._showSugg();
    const suggDesktop = this.querySelector('.WI_search_in_con_sugg_resultText');
    const suggMobile  = this.querySelector('.WI_search_results_sugg_resultText');
    if (suggDesktop) { suggDesktop.style.opacity = '0'; suggDesktop.style.display = 'none'; }
    if (suggMobile)  { suggMobile.style.opacity  = '0'; suggMobile.style.display  = 'none'; }
  }

  _initCarousel() {
    const ul      = this.querySelector('.WI_productResult_proUl');
    const prevBtn = this.querySelector('.WI_search_carousel_prev');
    const nextBtn = this.querySelector('.WI_search_carousel_next');
    if (!ul || !prevBtn || !nextBtn) return;

    const items   = ul.querySelectorAll('li');
    const visible = 4;
    const total   = items.length;

    if (total <= visible) {
      prevBtn.setAttribute('disabled', '');
      nextBtn.setAttribute('disabled', '');
      ul.style.transform = 'translateX(0)';
      return;
    }

    let index = 0;

    const update = () => {
      const cardW = items[0].offsetWidth + 14;
      ul.style.transform = `translateX(-${index * cardW}px)`;
      prevBtn.toggleAttribute('disabled', index === 0);
      nextBtn.toggleAttribute('disabled', index >= total - visible);
    };

    prevBtn.onclick = () => { if (index > 0) { index--; update(); } };
    nextBtn.onclick = () => { if (index < total - visible) { index++; update(); } };
    update();
  }

  openAndCloseSearchPop() {
    const openBtns   = document.querySelectorAll('.WI_openSearch');
    const closeBtn   = this.querySelector('.WI_search_in_close_btn');
    const panel      = this.querySelector('.WI_search_in');

    const openDrawer = () => {
      document.dispatchEvent(new CustomEvent('open:background', { bubbles: true }));
      this.style.display = 'block';
      requestAnimationFrame(() => {
        panel.style.transform = 'translateY(0%)';
        setTimeout(() => this.querySelector('input[type="search"]')?.focus(), 150);
      });
    };

    const closeDrawer = () => {
      panel.style.transform = 'translateY(-100%)';
      setTimeout(() => {
        this.style.display = 'none';
        document.dispatchEvent(new CustomEvent('close:background', { bubbles: true }));
      }, 420);
    };

    openBtns.forEach(btn => btn.addEventListener('click', openDrawer));
    closeBtn?.addEventListener('click', closeDrawer);
    this.addEventListener('click', e => {
      if (e.target === this) closeDrawer();
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && this.style.display !== 'none') closeDrawer();
    });
  }
}

customElements.define('wi-predictive-search', PredictiveSearch);
